import i18n from 'modules/core/lib/i18n'
import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

export const getSettingsItemsData = ({ navigation }: { navigation: Navigation<NavigationPaths> }) =>
  [
    {
      id: 'company',
      title: i18n.t('company_settings.general.title'),
      icon: 'control-navigation-adjust-sound',
      children: [
        {
          id: 'company_details',
          icon: 'multiple-buildings',
          title: i18n.t('company_settings.general.company_details.title'),
          description: i18n.t('company_settings.general.company_details.description'),
          url: navigation.settings.details.fullPath(),
          keywords: [
            i18n.t('company_settings.general.company_details.keywords.address'),
            i18n.t('company_settings.general.company_details.keywords.company_details'),
            i18n.t('company_settings.general.company_details.keywords.currency'),
            i18n.t('company_settings.general.company_details.keywords.legal_entities'),
            i18n.t('company_settings.general.company_details.keywords.legal_info'),
            i18n.t('company_settings.general.company_details.keywords.single_sign_on'),
            i18n.t('company_settings.general.company_details.keywords.sso'),
          ],
        },
        {
          id: 'workplaces',
          icon: 'buildings',
          title: i18n.t('company_settings.general.workplaces.title'),
          description: i18n.t('company_settings.general.workplaces.description'),
          url: navigation.settings.locations.fullPath(),
          keywords: [
            i18n.t('company_settings.general.workplaces.keywords.bank_holidays'),
            i18n.t('company_settings.general.workplaces.keywords.work_areas'),
            i18n.t('company_settings.general.workplaces.keywords.workplaces'),
          ],
        },
        {
          id: 'subscription',
          icon: 'boxes',
          title: i18n.t('company_settings.general.subscription.title'),
          description: i18n.t('company_settings.general.subscription.description'),
          url: navigation.settings.plans.fullPath(),
          keywords: [
            i18n.t('company_settings.general.subscription.keywords.billing'),
            i18n.t('company_settings.general.subscription.keywords.subscription'),
          ],
        },
        {
          id: 'customizations',
          icon: 'custom-file',
          title: i18n.t('company_settings.general.customization.title'),
          description: i18n.t('company_settings.general.customization.description'),
          url: navigation.settings.customizations.fullPath(),
          keywords: [
            i18n.t('company_settings.general.customization.keywords.career_page'),
            i18n.t('company_settings.general.customization.keywords.company_logo'),
            i18n.t('company_settings.general.customization.keywords.custom_fields'),
            i18n.t('company_settings.general.customization.keywords.custom_tables'),
            i18n.t('company_settings.general.customization.keywords.customization'),
            i18n.t('company_settings.general.customization.keywords.gender_options'),
            i18n.t('company_settings.general.customization.keywords.logo'),
          ],
        },
        {
          id: 'permissions',
          icon: 'permissions',
          title: i18n.t('company_settings.general.permissions.title'),
          description: i18n.t('company_settings.general.permissions.description'),
          url: navigation.settings.permissions.fullPath(),
          keywords: [
            i18n.t('company_settings.general.permissions.keywords.accesses'),
            i18n.t('company_settings.general.permissions.keywords.permissions'),
            i18n.t('company_settings.general.permissions.keywords.roles'),
          ],
        },
        {
          id: 'documents',
          icon: 'files',
          title: i18n.t('company_settings.general.documents.title'),
          description: i18n.t('company_settings.general.documents.description'),
          url: navigation.settings.folders.fullPath(),
          keywords: [
            i18n.t('company_settings.general.documents.keywords.documents'),
            i18n.t('company_settings.general.documents.keywords.folders'),
          ],
        },
        {
          id: 'external_users',
          icon: 'laptop-user',
          title: i18n.t('company_settings.general.externals.title'),
          description: i18n.t('settings.external_users.description'),
          url: navigation.settings.externals.fullPath(),
          keywords: [
            i18n.t('company_settings.general.externals.keywords.external'),
            i18n.t('company_settings.general.externals.keywords.users'),
          ],
        },
        {
          id: 'company-page',
          icon: 'page-edit',
          title: i18n.t('company_settings.general.company_page.title'),
          description: i18n.t('company_settings.general.company_page.description'),
          url: navigation.settings.company_page.fullPath(),
          keywords: [
            i18n.t('company_settings.general.company_page.keywords.company_page'),
            i18n.t('company_settings.general.company_page.keywords.domain'),
            i18n.t('company_settings.general.company_page.keywords.language'),
            i18n.t('company_settings.general.company_page.keywords.privacy_page_contact_email'),
            i18n.t('company_settings.general.company_page.keywords.subdomain'),
          ],
        },
        {
          id: 'security',
          icon: 'cog',
          title: i18n.t('company_settings.general.security.title'),
          description: i18n.t('company_settings.general.security.description'),
          url: navigation.settings.security.fullPath(),
          keywords: [
            i18n.t('company_settings.general.security.keywords.2fa'),
            i18n.t('company_settings.general.security.keywords.mfa'),
            i18n.t('company_settings.general.security.keywords.multifactor_auth'),
            i18n.t('company_settings.general.security.keywords.password'),
            i18n.t('company_settings.general.security.keywords.security'),
            i18n.t('company_settings.general.security.keywords.single_sign_on'),
            i18n.t('company_settings.general.security.keywords.sso'),
            i18n.t('company_settings.general.security.keywords.two_factor_auth'),
          ],
        },
        {
          id: 'contracts',
          icon: 'file',
          title: i18n.t('company_settings.general.employment_data.title'),
          description: i18n.t('company_settings.general.employment_data.description'),
          url: navigation.settings.contracts_settings.fullPath(),
          keywords: [i18n.t('company_settings.general.employment_data.keywords.contracts')],
        },
        {
          id: 'referral_program',
          icon: 'money-bag',
          title: i18n.t('company_settings.general.factorial_referral_program.settings_title'),
          description: i18n.t('company_settings.general.factorial_referral_program.description'),
          url: navigation.settings.referralProgram.fullPath(),
        },
        {
          id: 'universal_importer',
          icon: 'common-file-text-upload',
          title: i18n.t('company_settings.general.universal_importer.title'),
          description: i18n.t('company_settings.general.universal_importer.description'),
          url: navigation.settings.universalImporter.fullPath(),
        },
      ],
    },
    {
      id: 'time',
      title: i18n.t('company_settings.time.title'),
      icon: 'clock-app',
      children: [
        {
          id: 'time_off',
          icon: 'time-off',
          title: i18n.t('company_settings.time.time_off.title'),
          description: i18n.t('company_settings.time.time_off.description'),
          url: navigation.settings.timeoffPolicies.fullPath(),
          keywords: [
            i18n.t('company_settings.time.time_off.keywords.absence types'),
            i18n.t('company_settings.time.time_off.keywords.absences'),
            i18n.t('company_settings.time.time_off.keywords.blocked_periods'),
            i18n.t('company_settings.time.time_off.keywords.policies'),
            i18n.t('company_settings.time.time_off.keywords.policy'),
            i18n.t('company_settings.time.time_off.keywords.time_off'),
          ],
        },
        {
          id: 'time_tracking',
          icon: 'clock',
          title: i18n.t('company_settings.time.time_tracking.title'),
          description: i18n.t('company_settings.time.time_tracking.description'),
          url: navigation.settings.time_tracking.fullPath(),
          keywords: [
            i18n.t('company_settings.time.time_tracking.keywords.break'),
            i18n.t('company_settings.time.time_tracking.keywords.face_recognition'),
            i18n.t('company_settings.time.time_tracking.keywords.geolocation'),
            i18n.t('company_settings.time.time_tracking.keywords.night_shifts'),
            i18n.t('company_settings.time.time_tracking.keywords.overtime'),
            i18n.t('company_settings.time.time_tracking.keywords.policies'),
            i18n.t('company_settings.time.time_tracking.keywords.policy'),
            i18n.t('company_settings.time.time_tracking.keywords.time_tracking'),
            i18n.t('company_settings.time.time_tracking.keywords.time_tracking_policies'),
          ],
        },
        {
          id: 'work_schedules',
          icon: 'time-tracking',
          title: i18n.t('company_settings.time.work_schedules.title'),
          description: i18n.t('company_settings.time.work_schedules.description'),
          url: navigation.settings.workSchedule.fullPath(),
          keywords: [i18n.t('company_settings.time.work_schedules.keywords.work_schedule')],
        },
        {
          id: 'time_categories',
          icon: 'add-tag',
          title: i18n.t('company_settings.time.time_categories.title'),
          description: i18n.t('company_settings.time.time_categories.description'),
          url: navigation.settings.time_categories_settings.fullPath(),
          keywords: [
            i18n.t('company_settings.time.time_categories.keywords.breaks'),
            i18n.t('company_settings.time.time_categories.keywords.night_shifts'),
            i18n.t('company_settings.time.time_categories.keywords.overtime'),
            i18n.t('company_settings.time.time_categories.keywords.time_values'),
          ],
        },
      ],
    },
    {
      id: 'people',
      title: i18n.t('company_settings.people.title'),
      icon: 'group',
      children: [
        {
          id: 'complaints',
          icon: 'comment',
          title: i18n.t('company_settings.people.complaints.title'),
          description: i18n.t('company_settings.people.complaints.description'),
          url: navigation.settings.complaints.fullPath(),
          keywords: [
            i18n.t('company_settings.people.complaints.keywords.complaint'),
            i18n.t('company_settings.people.complaints.keywords.complaints'),
          ],
        },
        {
          id: 'engagement',
          icon: 'surveys',
          title: i18n.t('company_settings.people.engagement.title'),
          description: i18n.t('company_settings.people.engagement.description'),
          url: navigation.settings.engagement.fullPath(),
          keywords: [
            i18n.t('company_settings.people.engagement.keywords.engagement'),
            i18n.t('company_settings.people.engagement.keywords.pulse_survey'),
          ],
        },
        {
          id: 'onboarding',
          icon: 'onboarding',
          title: i18n.t('company_settings.people.onboarding.title'),
          description: i18n.t('company_settings.people.onboarding.description'),
          url: navigation.settings.employee_onboarding.fullPath(),
          keywords: [
            i18n.t('company_settings.people.onboarding.keywords.employee_onboarding'),
            i18n.t('company_settings.people.onboarding.keywords.onboarding'),
          ],
        },
        {
          id: 'recruitment',
          icon: 'user-search',
          title: i18n.t('company_settings.people.recruitment.title'),
          description: i18n.t('company_settings.people.recruitment.description'),
          url: navigation.settings.ats.fullPath(),
          keywords: [
            i18n.t('company_settings.people.recruitment.keywords.ats'),
            i18n.t('company_settings.people.recruitment.keywords.recruitment'),
            i18n.t('company_settings.people.recruitment.keywords.talent'),
          ],
        },
        {
          id: 'performance_process',
          icon: 'performance',
          title: i18n.t('company_settings.people.performance_process.title'),
          description: i18n.t('company_settings.people.performance_process.description'),
          url: navigation.settings.performanceProcess.fullPath(),
          keywords: [
            i18n.t('company_settings.people.reviews.keywords.performance'),
            i18n.t('company_settings.people.reviews.keywords.reviews'),
          ],
        },
        {
          id: 'surveys',
          icon: 'checks',
          title: i18n.t('company_settings.people.surveys.title'),
          description: i18n.t('company_settings.people.surveys.description'),
          url: navigation.settings.surveys.fullPath(),
          keywords: [
            i18n.t('company_settings.people.surveys.keywords.feedback'),
            i18n.t('company_settings.people.surveys.keywords.surveys'),
          ],
        },
        {
          id: 'trainings',
          icon: 'bookmark',
          title: i18n.t('company_settings.people.training.title'),
          description: i18n.t('company_settings.people.training.description'),
          url: navigation.settings.trainings.fullPath(),
          keywords: [i18n.t('company_settings.people.training.keywords.training')],
        },
      ],
    },
    {
      id: 'it',
      title: i18n.t('company_settings.it.title'),
      icon: 'window-user',
      children: [
        {
          id: 'it_inventory',
          icon: 'sync',
          title: i18n.t('company_settings.it.it_inventory.title'),
          description: i18n.t('company_settings.it.it_inventory.description'),
          url: navigation.settings.it_inventory.fullPath(),
          keywords: [
            i18n.t('company_settings.it.it_inventory.keywords.devices'),
            i18n.t('company_settings.it.it_inventory.keywords.equipment'),
            i18n.t('company_settings.it.it_inventory.keywords.assets'),
          ],
        },
      ],
    },
    {
      id: 'finance',
      title: i18n.t('company_settings.finance.title'),
      icon: 'pig',
      children: [
        {
          id: 'payroll',
          icon: 'money',
          title: i18n.t('company_settings.finance.payroll.title'),
          description: i18n.t('company_settings.finance.payroll.description'),
          url: navigation.settings.payroll_bundle.fullPath(),
          keywords: [
            i18n.t('company_settings.finance.payroll.keywords.bookkeeper'),
            i18n.t('company_settings.finance.payroll.keywords.payroll'),
            i18n.t('company_settings.finance.payroll.keywords.policies'),
            i18n.t('company_settings.finance.payroll.keywords.policy'),
            i18n.t('company_settings.finance.payroll.keywords.reimbursement'),
          ],
        },
        {
          id: 'compensations',
          icon: 'money',
          title: i18n.t('company_settings.finance.compensations.title'),
          description: i18n.t('company_settings.finance.compensations.description'),
          url: navigation.settings.compensations.fullPath(),
          keywords: [
            i18n.t('company_settings.finance.payroll.keywords.payroll'),
            i18n.t('company_settings.finance.payroll.keywords.policies'),
            i18n.t('company_settings.finance.payroll.keywords.policy'),
            i18n.t('company_settings.finance.payroll.keywords.reimbursement'),
          ],
        },
        {
          id: 'benefits',
          icon: 'gift',
          title: i18n.t('company_settings.finance.benefits.title'),
          description: i18n.t('company_settings.finance.benefits.description'),
          url: navigation.settings.benefits.fullPath(),
          keywords: ['benefits'],
        },
        {
          id: 'salary_advance',
          icon: 'money',
          title: i18n.t('company_settings.finance.salary_advance.title'),
          description: i18n.t('company_settings.finance.salary_advance.description'),
          url: navigation.settings.salaryAdvance.fullPath(),
          keywords: ['salary advance', 'advance'],
        },
        {
          id: 'software',
          icon: 'floppy-disk',
          title: i18n.t('company_settings.finance.software.title'),
          description: i18n.t('company_settings.finance.software.description'),
          url: navigation.settings.software.fullPath(),
        },
        {
          id: 'expenses',
          icon: 'receipt',
          title: i18n.t('company_settings.finance.expenses.title'),
          description: i18n.t('company_settings.finance.expenses.description'),
          url: navigation.settings.expenses.fullPath(),
          keywords: [i18n.t('company_settings.finance.expenses.keywords.expenses')],
        },
        {
          id: 'cost_centers',
          icon: 'money-bag',
          title: i18n.t('company_settings.finance.cost_centers.title'),
          description: i18n.t('company_settings.finance.cost_centers.description'),
          url: navigation.settings.finance.costCenters.fullPath(),
          keywords: [
            i18n.t('company_settings.finance.cost_centers.keywords.cost_centers'),
            i18n.t('company_settings.finance.cost_centers.keywords.custom_dimensions'),
            i18n.t('company_settings.finance.cost_centers.keywords.workspace'),
          ],
        },
        {
          id: 'analytical_dimensions',
          icon: 'performance',
          title: i18n.t('company_settings.finance.analytical_dimensions.title'),
          description: i18n.t('company_settings.finance.analytical_dimensions.description'),
          url: navigation.settings.finance.fullPath(),
          keywords: [
            i18n.t('company_settings.finance.cost_centers.keywords.cost_centers'),
            i18n.t('company_settings.finance.cost_centers.keywords.custom_dimensions'),
            i18n.t('company_settings.finance.cost_centers.keywords.workspace'),
          ],
        },
        {
          id: 'accounting',
          icon: 'money-bag',
          title: i18n.t('company_settings.finance.accounting.title'),
          description: i18n.t('company_settings.finance.accounting.description'),
          url: navigation.settings.finance.accounting.fullPath(),
          keywords: [i18n.t('company_settings.finance.accounting.keywords.accounting')],
        },
        {
          id: 'sales',
          icon: 'contract-handshake',
          title: i18n.t('company_settings.finance.sales_settings.title'),
          description: i18n.t('company_settings.finance.sales_settings.description'),
          url: navigation.settings.finance.sales.fullPath(),
          keywords: [
            i18n.t('company_settings.finance.sales_settings.keywords.sales'),
            i18n.t('company_settings.finance.sales_settings.keywords.sales_invoice'),
            i18n.t('company_settings.finance.sales_settings.keywords.serial_sequence'),
          ],
        },
        {
          id: 'purchase_requests',
          icon: 'receipt',
          title: i18n.t('company_settings.finance.procurement.title'),
          description: i18n.t('company_settings.finance.procurement.description'),
          url: navigation.settings.procurement.fullPath(),
          keywords: [
            i18n.t('company_settings.finance.procurement.keywords.approval_groups'),
            i18n.t('company_settings.finance.procurement.keywords.purchase_requests'),
          ],
        },
        {
          id: 'financial_workspace',
          icon: 'data',
          title: i18n.t('company_settings.finance.financial_workspace.title'),
          description: i18n.t('company_settings.finance.financial_workspace.description'),
          url: navigation.settings.financialWorkspace.fullPath(),
          keywords: [
            i18n.t('company_settings.finance.financial_workspace.keywords.financial_workspace'),
          ],
        },
      ],
    },
    {
      id: 'advanced',
      title: i18n.t('company_settings.advanced.title'),
      icon: 'flask',
      children: [
        {
          id: 'api_keys',
          icon: 'network-group',
          title: i18n.t('company_settings.advanced.api_keys.title'),
          description: i18n.t('company_settings.advanced.api_keys.description'),
          url: navigation.settings.apiKeys.fullPath(),
          keywords: [
            i18n.t('company_settings.advanced.api_keys.keywords.api'),
            i18n.t('company_settings.advanced.api_keys.keywords.api_keys'),
            i18n.t('company_settings.advanced.api_keys.keywords.keys'),
          ],
        },
        {
          id: 'audit_log',
          icon: 'file-search',
          title: i18n.t('company_settings.advanced.audit_log.title'),
          description: i18n.t('company_settings.advanced.audit_log.description'),
          url: navigation.settings.auditLog.fullPath(),
          keywords: [
            i18n.t('company_settings.advanced.audit_log.keywords.audit_log'),
            i18n.t('company_settings.advanced.audit_log.keywords.audits'),
          ],
        },
        {
          id: 'custom_notifications',
          icon: 'workflow',
          title: i18n.t('company_settings.advanced.custom_notifications.title'),
          description: i18n.t('company_settings.advanced.custom_notifications.description'),
          url: navigation.settings.automations.fullPath(),
          keywords: [
            i18n.t('company_settings.advanced.custom_notifications.keywords.automation'),
            i18n.t('company_settings.advanced.custom_notifications.keywords.custom_notifications'),
          ],
        },
        {
          id: 'approvals',
          icon: 'checks',
          title: i18n.t('company_settings.advanced.approvals.title'),
          description: i18n.t('company_settings.advanced.approvals.description'),
          url: '/settings/approval-groups',
        },
      ],
    },
  ] as const

type ArrayElement<ArrayType extends readonly unknown[]> =
  ArrayType extends readonly (infer ElementType)[] ? ElementType : never

type ConstSettings = ArrayElement<ReturnType<typeof getSettingsItemsData>>

type IdType<T> = T extends { id: infer U } ? U : never

type ExtractId<T> = T extends readonly (infer U)[]
  ? ExtractId<U>
  : T extends { children: readonly (infer N)[] }
  ? IdType<T> | ExtractId<N>
  : IdType<T>

export type SettingId = ExtractId<ConstSettings>
